/**MTNTopBar.js — NOC-style SSOT signal bar for MTN workspace */
import React from "react";
import { useMTN } from "@/context/MTNContext";
import { ChevronDown, AlertTriangle, Signal } from "lucide-react";
import { useState } from "react";

export default function MTNTopBar() {
  const { group, selectedPeriod, setSelectedPeriod, periods } = useMTN();
  const [open, setOpen] = useState(false);
  const totalTco2e = group.total_tco2e || 0;
  const renewPct   = group.group_renewable_pct || 0;
  const dieselDep  = group.group_diesel_dep || 0;
  const dataConf   = group.data_confidence_avg || 0;
  const periodLabel = periods.find(p => p.period_id === selectedPeriod)?.label || selectedPeriod;

  return (
    <div style={{ background:"#0a0f1e", borderBottom:"1px solid #1e293b", padding:"0 20px",
      display:"flex", alignItems:"center", gap:12, height:44, flexShrink:0, position:"sticky", top:0, zIndex:10 }}
      data-testid="ssot-signal-bar">
      {/* Period selector */}
      <div style={{ position:"relative" }}>
        <button onClick={() => setOpen(!open)}
          style={{ display:"flex", alignItems:"center", gap:5, background:"#0f172a",
            border:"1px solid #334155", borderRadius:5, padding:"3px 8px", cursor:"pointer" }}>
          <Signal size={10} color="#FFCB00" />
          <span style={{ fontSize:9, color:"#94a3b8", fontWeight:600 }}>{periodLabel}</span>
          <ChevronDown size={9} color="#475569" />
        </button>
        {open && (
          <div style={{ position:"absolute", top:"100%", left:0, background:"#0f172a", border:"1px solid #334155",
            borderRadius:5, zIndex:50, minWidth:180, boxShadow:"0 8px 24px rgba(0,0,0,.6)", marginTop:2 }}>
            {periods.map(p => (
              <button key={p.period_id} onClick={() => { setSelectedPeriod(p.period_id); setOpen(false); }}
                style={{ width:"100%", padding:"6px 10px", textAlign:"left", fontSize:9, color:"#94a3b8",
                  background:p.period_id===selectedPeriod?"#1e293b":"transparent", border:"none", cursor:"pointer" }}>
                {p.label}
              </button>
            ))}
          </div>
        )}
      </div>

      <div style={{ width:1, height:20, background:"#1e293b" }} />

      {/* SSOT Live */}
      <div style={{ display:"flex", alignItems:"center", gap:5 }}>
        <div style={{ width:6, height:6, borderRadius:"50%", background:"#22c55e", boxShadow:"0 0 5px #22c55e" }} />
        <span style={{ fontSize:8, color:"#22c55e", fontWeight:700, letterSpacing:".05em" }}>SSOT LIVE</span>
      </div>

      {/* Metrics */}
      {[
        ["Emissions", `${totalTco2e>=1e6?(totalTco2e/1e6).toFixed(1)+"M":(totalTco2e/1e3).toFixed(0)+"K"} tCO₂e`, "#f59e0b"],
        ["Renewable", `${renewPct.toFixed(0)}%`, renewPct>=20?"#22c55e":"#f59e0b"],
        ["Diesel Dep.", `${dieselDep.toFixed(0)}%`, dieselDep>50?"#ef4444":"#f59e0b"],
        ["Confidence", `${dataConf.toFixed(0)}/100`, dataConf>=65?"#22c55e":"#ef4444"],
        ["Towers", `${(group.total_towers||0).toLocaleString()}`, "#60a5fa"],
      ].map(([lbl, val, col]) => (
        <div key={lbl} style={{ display:"flex", alignItems:"center", gap:5, padding:"0 8px",
          borderLeft:"1px solid #1e293b" }}>
          <span style={{ fontSize:8, color:"#475569" }}>{lbl}</span>
          <span style={{ fontSize:9, fontWeight:700, color:col }}>{val}</span>
        </div>
      ))}

      {dataConf < 65 && (
        <div style={{ marginLeft:"auto", display:"flex", alignItems:"center", gap:4,
          background:"#7c2d1220", border:"1px solid #dc262630", borderRadius:5, padding:"2px 8px" }}>
          <AlertTriangle size={9} color="#f87171" />
          <span style={{ fontSize:8, color:"#f87171", fontWeight:600 }}>Evidence quality below VVB threshold (65/100)</span>
        </div>
      )}
    </div>
  );
}
